export default {
    title: 'Envios',
    addSettlementShortLabel: 'Novo',
    addSettlement: 'Criar envio',
    filterLabel: 'Filtrar por',
    resultLabel: '{result} resultado | {result} resultados',
    lastUpdateLabel: 'Última atualização: {datetime}',
    orderLabel: 'Ordenar por',
    loadingDataLabel: 'Obtendo envio',
    emptyDataLabel: 'nenhum resultado encontrado',
    tryAgainLabel: 'Tente pesquisar outro termo ou',
    paginationSizeLabel: 'Resultados/página',
    cleanFilters: 'limpando os filtros',
    filtersAppliedLabel: 'aplicado',
    status: {
        inProgress: 'Em andamento',
        completed: 'Pago',
        sentToSponsor: 'Enviado',
        rejectedBySponsor: 'Recusado',
        approvedBySponsor: 'Liquidado',
        error: 'Erro',
    },
    filters: {
        status: 'Status',
        sponsor: 'Operadora',
        from: 'De',
        to: 'Até',
        searchCode: 'Pesquisar por ID',
        dateRange: 'Período',
    },
    settlementGrid: {
        code: 'ID do envio',
        createdAt: 'Data de criação',
        sponsor: 'Operadora',
        amount: 'Valor a ser cobrado',
        authorizations: 'Autorizações',
        status: 'Status',
        medicalAccount: 'Número da nota fiscal médica',
    },
    sponsors: {
        DO: {
            humano: 'Seguro Humano',
            universal: 'ARS universal',
            primera: 'ARS Primeira',
        }
    },
    creation: {
        success: 'O envio foi criado com sucesso',
        error: 'Ocorreu um erro na criação do envio',
    },
    documentation: {
        complete: 'Completa',
        incomplete: '({uploaded}/{total}) Documentos',
        incompleteMessage: 'Documentação incompleta',
    },
    documentType: {
        invoiceFile: 'documento de fatura',
        creditNoteFile: 'Nota de crédito',
        debitNoteFile: 'Nota de débito',
    }
}